import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Badge, Dropdown } from 'antd';
import {
  CaretUpFilled,
  ExclamationCircleOutlined,
  SoundFilled
} from '@ant-design/icons';
import { Spin } from 'antd';
import { formatTimeDifference } from '../../../../util/timezone';
import {
  NotificationMenuWrapper,
  StyledBellIcon,
  StyledMenu,
  StyledMenuItem,
  StyledCustomLink
} from './styled';
import { withRouter } from 'react-router-dom';

const NotificationsDropdown = ({
  history,
  getAMLSCommonNotifications,
  notifications = [],
  notificationsApiStatus = false
}) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [hasNewNotifications, setHasNewNotifications] = useState(true);

  const handleMenuClick = (e) => {
    setDropdownVisible(true);
  };

  useEffect(() => {
    if (dropdownVisible) getAMLSCommonNotifications();
  }, [dropdownVisible]);

  const triggerButton = (
    <div
      onClick={() => setDropdownVisible(!dropdownVisible)}
      style={{
        display: 'flex',
        position: 'relative'
      }}>
      <div style={{ display: 'inline-block' }}>
        {notifications?.length ? (
          <Badge
            dot={hasNewNotifications}
            offset={[-12, 4]}
            style={{
              backgroundColor: hasNewNotifications ? '#FF7B7B' : 'transparent',
              boxShadow: 'none'
            }}>
            <StyledBellIcon />
          </Badge>
        ) : (
          <StyledBellIcon />
        )}
      </div>
      {dropdownVisible && (
        <div
          id="topbar-id"
          style={{
            display: 'inline-block',
            marginTop: '18px',
            position: 'absolute'
          }}>
          <CaretUpFilled
            style={{
              fontSize: '20px',
              color: 'white',
              marginTop: '2px'
            }}
          />
        </div>
      )}
    </div>
  );

  const handleClickNotification = (notification) => {
    if (notification.text.toLowerCase().includes('scan completed')) {
      history.push({
        pathname: `/app/smart-screening/on-demand-screening`,
        search: '?tabId=4',
        state: {
          jobId: notification?.additionalProperties?.jobId
        }
      });
    }
  };

  return (
    <Dropdown
      id="topbar-dropdown"
      overlay={
        <NotificationMenuWrapper>
          <StyledMenu onClick={handleMenuClick}>
            <StyledMenuItem
              key="1"
              style={{
                height: '48px',
                borderBottom: '1px solid #f7f7f8',
                margin: '0px'
              }}>
              <p
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '23px',
                  margin: '0px',
                  padding: '16px 6px'
                }}>
                <span>Notifications</span>
                {notificationsApiStatus ? (
                  <Spin size="small" />
                ) : (
                  <SoundFilled
                    style={{
                      fontSize: '14px',
                      backgroundColor: '#1c3145',
                      color: '#FFFFFF',
                      padding: '0px 6px'
                    }}
                  />
                )}
              </p>
            </StyledMenuItem>
            {notifications && notifications?.length ? (
              notifications?.map((i, index) => {
                return (
                  <StyledMenuItem
                    key={index + 2}
                    style={{
                      height: '56px',
                      borderBottom: '1px solid #f7f7f8',
                      justifyContent: 'space-around',
                      margin: '0px'
                    }}>
                    <div onClick={() => handleClickNotification(i)}>
                      <span className="bullet-text">&#8226;</span>
                      <span className="notification-text">{i.text}</span>
                      <span
                        style={{
                          color: '#D0D7E3',
                          marginRight: '4px',
                          lineHeight: '16px',
                          fontSize: '10px',
                          fontWeight: 'bold'
                        }}>
                        <span className="bullet-time">&#8226;</span>
                        {formatTimeDifference(i.createdAt)}
                      </span>
                    </div>
                  </StyledMenuItem>
                );
              })
            ) : (
              <>
                {!notificationsApiStatus && (
                  <StyledMenuItem
                    key="2"
                    style={{
                      height: '56px',
                      borderBottom: '1px solid #f7f7f8',
                      justifyContent: 'space-around',
                      margin: '0px'
                    }}>
                    <p
                      style={{
                        lineHeight: '16px',
                        color: '#D0D7E3',
                        fontSize: '12px'
                      }}>
                      No records found
                      <ExclamationCircleOutlined />
                    </p>
                  </StyledMenuItem>
                )}
              </>
            )}
          </StyledMenu>
        </NotificationMenuWrapper>
      }
      trigger={['click']}
      visible={dropdownVisible}
      onVisibleChange={(visible) => setDropdownVisible(visible)}
      placement="bottomLeft">
      {triggerButton}
    </Dropdown>
  );
};

NotificationsDropdown.propTypes = {
  getAMLSCommonNotifications: PropTypes.func,
  notifications: PropTypes.array,
  notificationsApiStatus: PropTypes.bool
};

export default withRouter(NotificationsDropdown);
